import axios from 'axios';
import { createSlice } from '@reduxjs/toolkit';

const widgetSlice = createSlice({
  name: 'WIDGET',
  initialState: {
    response: null,
    isValidCaptcha: true,
    errorMessage: null,
    loading: false,
  },
  reducers: {
    createMessage: (state, action) =>
      ({
        ...state,
        response: action.payload.widget,
      }),
    setError: (state, action) =>
      ({
        ...state,
        response: action.payload,
      }),
    clearState: (state) =>
      ({
        ...state,
        response: null,
        isValidCaptcha: true,
        errorMessage: null,
        loading: false,
      }),
    invalidCaptcha: (state, action) =>
      ({
        ...state,
        ...action.payload,
      }),
    setLoading: (state, action) =>
      ({
        ...state,
        ...action.payload,
      }),
    widgetConfiguration: (state, action) =>
      ({
        ...state,
        ...action.payload,
      }),
  },
});

export default widgetSlice.reducer;

// ACTIONS
export const {
  createMessage,
  setError,
  clearState,
  invalidCaptcha,
  setLoading,
  widgetConfiguration,
} = widgetSlice.actions;

// THUNKS -- ASYNC ACTION CREATORS

export function createWidgetMessage(payload) {
  return (dispatch) => {
    dispatch(setLoading({ loading: true }));
    axios.post(`${process.env.REACT_APP_V3_BASE_URL}/webform/messaging`, payload)
      .then((response) => {
        if (response.status === 204) {
          dispatch(createMessage({ widget: 'success' }));
        } else {
          dispatch(setError('error'));
        }
        dispatch(setLoading({ loading: false }));
      })
      .catch((err) => {
        console.error(err.response || err);
        if (err.response && err.response.status && err.response.status === 403) {
          dispatch(invalidCaptcha({ isValidCaptcha: false, errorMessage: err.response.data && err.response.data.message }));
        } else {
          dispatch(setError('error'));
        }
        dispatch(setLoading({ loading: false }));
      });
  };
}

export function clearWidgetState() {
  return (dispatch) => {
    dispatch(clearState());
  };
}

export function fetchWidgetConfiguration(webFormId) {
  return axios.get(`/webhooks/widget/configuration/${webFormId}`)
    .then((response) => response.data);
}
